module.exports = __webpack_public_path__ + "static/img/vip.91ba2165.png";